<template>
    <div class="w-full h-full">
        <input type="hidden" :name="$attrs.name" :id="$attrs.name" :value="JSON.stringify(translation)">
        <div class="border-b border-gray-200">
            <ul class="flex flex-wrap -mb-px text-sm font-medium text-center items-center"
                :id="$attrs.name + 'translationTab'" :data-tabs-toggle="$attrs.name + 'translationTabular'" role="tablist">
                <li v-for="text, locale in translation" class="mr-1" role="presentation"
                    :key="locale + '_' + translation.length">
                    <button @click="switchLocale"
                        class="bg-gray-200 px-2 py-2 border border-gray-300 border-b-0 text-gray-900 text-xs rounded-t-lg group hover:bg-gray-100 hover:text-gray-900 active:bg-gray-300 transition duration-300"
                        :class="[activeTab == locale ? 'bg-white' : '']" :id="$attrs.name + locale + '-tab'"
                        :target="locale" type="button">
                        <span
                            class="text-xs group-hover:scale-95 group-active:scale-75 transition duration-300 inline-block pointer-events-none">
                            {{ $t(locale) }}
                        </span>
                    </button>
                </li>

                <app_modal ref="appModal">
                    <template slot="modal_content">
                        <div class="bg-white rounded-md shadow-xl p-8 animate-in fade-in zoom-in w-full max-w-md">
                            <div class="flex flex-col justify-between justify-items-center">
                                <div class="flex justify-between items-center gap-4">
                                    <span @click="addLanguage('nl'), $refs.appModal.closeModal()"
                                        class="cursor-pointer hover:scale-95 active:scale-75 transition duration-300"><country-flag
                                            country='nl' size='big' :rounded="true" /></span>
                                    <span @click="addLanguage('de'), $refs.appModal.closeModal()"
                                        class="cursor-pointer hover:scale-95 active:scale-75 transition duration-300"><country-flag
                                            country='de' size='big' :rounded="true" /></span>
                                    <span @click="addLanguage('fr'), $refs.appModal.closeModal()"
                                        class="cursor-pointer hover:scale-95 active:scale-75 transition duration-300"><country-flag
                                            country='fr' size='big' :rounded="true" /></span>
                                    <span @click="addLanguage('es'), $refs.appModal.closeModal()"
                                        class="cursor-pointer hover:scale-95 active:scale-75 transition duration-300"><country-flag
                                            country='es' size='big' :rounded="true" /></span>
                                    <span @click="addLanguage('pt'), $refs.appModal.closeModal()"
                                        class="cursor-pointer hover:scale-95 active:scale-75 transition duration-300"><country-flag
                                            country='pt' size='big' :rounded="true" /></span>
                                </div>
                                <div class="relative flex py-5 items-center mb-4">
                                    <div class="flex-grow border-t border-gray-400"></div>
                                    <span class="flex-shrink mx-4 text-gray-400">{{ $t('or') }}</span>
                                    <div class="flex-grow border-t border-gray-400"></div>
                                </div>
                                <country-select v-model="country" :country="country" class="rounded-full"
                                    :usei18n="false" />
                                <button @click="addLanguage(), $refs.appModal.closeModal()" type="button"
                                    class="py-2.5 px-5 me-2 mt-5 text-sm font-medium text-white focus:outline-none bg-primary rounded-full border border-gray-200 hover:bg-primary-dark focus:z-10 focus:ring-4 focus:ring-gray-200">{{
                                        $t('Add Language') }}</button>
                            </div>
                        </div>
                    </template>


                    <template slot="modal_button">
                        <li role="presentation">
                            <button type="button"
                                class="w-6 h-6 flex justify-center items-center border border-gray-300 text-gray-900 text-xs rounded-full hover:bg-white hover:scale-95 active:scale-75 transition duration-300">
                                <span class="text-xs">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3" fill="currentColor"
                                        viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.-->
                                        <path
                                            d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z" />
                                    </svg>
                                </span>
                            </button>
                        </li>
                    </template>
                </app_modal>


            </ul>
        </div>
        <div :id="$attrs.name + 'translationTabular'">
            <div v-for="text, locale in translation" :ref="locale + '_' + $attrs.name + '_tab'"
                class="hidden rounded-tr-lg rounded-br-lg rounded-bl-lg bg-gray-50" :id="$attrs.name + '_' + locale"
                :class="[activeTab == locale ? '!block' : 'hidden']">
                <input v-if="$attrs.variant == 'text'" type="text" :name="$attrs.name + '_' + locale + '_val'"
                    :id="$attrs.name + '_' + locale + '_val'" v-model="translation[locale]"
                    :placeholder="$attrs.name + '...'"
                    :class="'bg-white border border-gray-300 text-gray-900 text-base rounded-tr-lg rounded-br-lg rounded-bl-lg block w-full p-2.5 focus:ring-0 focus:border-gray-600 ' + $attrs.extraclasses">
                <!-- <ckeditor v-else-if="$attrs.variant == 'textarea'" :editor="editor" v-model="translation[locale]"
                    :editorConfig="editorConfig" :name="$attrs.name + '_' + locale + '_val'"
                    :id="$attrs.name + '_' + locale + '_val'"></ckeditor> -->

                <textarea v-else-if="$attrs.variant == 'textarea'" class="js_convert_wysiwyg hidden"
                    :class="$attrs.extraClasses" :data-lang="locale" :name="$attrs.name + '_val[' + locale + ']'"
                    :id="$attrs.name + '_' + locale + '_val'" v-html="translation[locale]"></textarea>
            </div>
        </div>
    </div>
</template>

<script>

// import ClassicEditor from '@ckeditor/ckeditor5-build-document';
// import ImageResize from "@ckeditor/ckeditor5-image/src/imageresize";
// import { SourceEditing } from '@ckeditor/ckeditor5-source-editing';

export default {
    data() {
        return {
            translation: this.$attrs.use_capitals ? this.$attrs.value && this.$attrs.value != "[]" ? JSON.parse(this.$attrs.value) : this.$attrs.value != "[]" ? { 'EN': this.$attrs.value } : { "EN": "" } : this.$attrs.value && this.$attrs.value != "[]" ? JSON.parse(this.$attrs.value) : this.$attrs.value != "[]" ? { 'en': this.$attrs.value } : { "en": "" },
            addingLanguage: false,
            country: '',
            renderComponent: true,
            activeTab: this.$attrs.use_capitals ? 'EN' : 'en',
            convertedTranslation: '',
            // editor: ClassicEditor,
            editorConfig: {
            }
        };
    },
    methods: {
        async forceRender() {
            this.renderComponent = false;
            await this.$nextTick();
            this.renderComponent = true;
        },
        addLanguage(lang) {
            if (this.$attrs.use_capitals) {
                if (lang) {
                    this.$set(this.translation, lang.toUpperCase(), "")
                    this.forceRender();
                } else {
                    this.$set(this.translation, this.country.toUpperCase(), "")
                    this.forceRender();
                }
            } else {
                if (lang) {
                    this.$set(this.translation, lang, "")
                    this.forceRender();
                } else {
                    this.$set(this.translation, this.country.toLowerCase(), "")
                    this.forceRender();
                }
            }
        },
        switchLocale() {
            this.activeTab = event.target.getAttribute('target');
            var target = event.target.getAttribute('target') + '_' + this.$attrs.name + '_tab';
            var that = this;
            setTimeout(function () {
                if (that.$attrs.variant == "text") {
                    that.$refs[target][0].querySelector('input').focus();
                } else if (that.$attrs.variant == "textarea") {
                    if (that.$attrs.use_capitals) {
                        that.$refs[target][0].querySelector('#cke_body_EN').focus();
                    } else {
                        that.$refs[target][0].querySelector('#cke_body_en').focus();
                    }
                }
            }, 200);
        },
        buildNewTranslation() {
            console.log('here');
        }
    },
    created() {
        var _this = this;
        setTimeout(function () {
            var editors = document.getElementsByClassName("js_convert_wysiwyg");
            for (var i = 0; i < editors.length; i++) {
                var token = _this.$attrs.csrf_token;
                CKEDITOR.ClassicEditor.create(editors[i], {
                    // https://ckeditor.com/docs/ckeditor5/latest/features/toolbar/toolbar.html#extended-toolbar-configuration-format
                    toolbar: {
                        plugins: ['Image'],
                        items: [
                            'findAndReplace', 'selectAll', '|',
                            'heading', '|',
                            'bold', 'italic', 'strikethrough', 'underline', 'code', 'subscript', 'superscript', 'removeFormat', '|',
                            'bulletedList', 'numberedList', 'todoList', '|',
                            'outdent', 'indent', '|',
                            'undo', 'redo',
                            '-',
                            'fontSize', 'fontFamily', 'fontColor', 'fontBackgroundColor', 'highlight', '|',
                            'alignment', '|',
                            'link', 'insertImage', 'blockQuote', 'insertTable', 'mediaEmbed', 'codeBlock', 'htmlEmbed', '|',
                            'specialCharacters', 'horizontalLine', 'pageBreak', '|',
                            'textPartLanguage', '|',
                            'sourceEditing'
                        ],
                        shouldNotGroupWhenFull: true
                    },
                    ckfinder: {
                        uploadUrl: Vue.prototype.$baseUrl + '/vimata/imageUpload?_token=' + token,
                    },
                    image: {
                        insert: {
                            // This is the default configuration, you do not need to provide
                            // this configuration key if the list content and order reflects your needs.
                            integrations: ['upload', 'assetManager', 'url']
                        },
                        resizeOptions: [
                            {
                                name: 'resizeImage:original',
                                value: null,
                                label: 'Original'
                            },
                            {
                                name: 'resizeImage:33',
                                value: '33',
                                label: '33%'
                            },
                            {
                                name: 'resizeImage:50',
                                value: '50',
                                label: '50%'
                            }
                        ]
                    },
                    // Be careful with the setting below. It instructs CKEditor to accept ALL HTML markup.
                    // https://ckeditor.com/docs/ckeditor5/latest/features/general-html-support.html#enabling-all-html-features
                    htmlSupport: {
                        allow: [
                            {
                                name: /.*/,
                                attributes: true,
                                classes: true,
                                styles: true
                            }
                        ]
                    },
                    // Be careful with enabling previews
                    // https://ckeditor.com/docs/ckeditor5/latest/features/html-embed.html#content-previews
                    htmlEmbed: {
                        showPreviews: true
                    },
                    mediaEmbed: {
                        previewsInData: true
                    },
                    // https://ckeditor.com/docs/ckeditor5/latest/features/link.html#custom-link-attributes-decorators
                    link: {
                        decorators: {
                            addTargetToExternalLinks: true,
                            defaultProtocol: 'https://',
                            toggleDownloadable: {
                                mode: 'manual',
                                label: 'Downloadable',
                                attributes: {
                                    download: 'file'
                                }
                            },
                            openInNewTab: {
                                mode: 'manual',
                                label: 'Open in a new tab',
                                attributes: {
                                    target: '_blank',
                                    rel: 'noopener noreferrer'
                                }
                            }
                        }
                    },
                    heading: {
                        options: [
                            { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                            { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                            { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                            { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' }
                        ]
                    },
                    removePlugins: [
                        // These two are commercial, but you can try them out without registering to a trial.
                        // 'ExportPdf',
                        // 'ExportWord',
                        'AIAssistant',
                        'CKBox',
                        'CKFinder',
                        // 'EasyImage',
                        // This sample uses the Base64UploadAdapter to handle image uploads as it requires no configuration.
                        // https://ckeditor.com/docs/ckeditor5/latest/features/images/image-upload/base64-upload-adapter.html
                        // Storing images as Base64 is usually a very bad idea.
                        // Replace it on production website with other solutions:
                        // https://ckeditor.com/docs/ckeditor5/latest/features/images/image-upload/image-upload.html
                        'Base64UploadAdapter',
                        'RealTimeCollaborativeComments',
                        'RealTimeCollaborativeTrackChanges',
                        'RealTimeCollaborativeRevisionHistory',
                        'PresenceList',
                        'Comments',
                        'TrackChanges',
                        'TrackChangesData',
                        'RevisionHistory',
                        'Pagination',
                        'WProofreader',
                        // Careful, with the Mathtype plugin CKEditor will not load when loading this sample
                        // from a local file system (file://) - load this site via HTTP server if you enable MathType.
                        'MathType',
                        // The following features are part of the Productivity Pack and require additional license.
                        'SlashCommand',
                        'Template',
                        'DocumentOutline',
                        'FormatPainter',
                        'TableOfContents',
                        'PasteFromOfficeEnhanced'
                    ]
                })
                editors[i].classList.remove('js_convert_wysiwyg');
            }

        }, 500);
    },
    watch: {
        translation: {
            immediate: true,
            handler(oldValue, newValue) {
                var _this = this;
                setTimeout(function () {
                    var editors = document.getElementsByClassName("js_convert_wysiwyg");
                    for (var i = 0; i < editors.length; i++) {
                        var token = _this.$attrs.csrf_token;
                        CKEDITOR.ClassicEditor.create(editors[i], {
                            // https://ckeditor.com/docs/ckeditor5/latest/features/toolbar/toolbar.html#extended-toolbar-configuration-format
                            toolbar: {
                                plugins: ['Image'],
                                items: [
                                    'findAndReplace', 'selectAll', '|',
                                    'heading', '|',
                                    'bold', 'italic', 'strikethrough', 'underline', 'code', 'subscript', 'superscript', 'removeFormat', '|',
                                    'bulletedList', 'numberedList', 'todoList', '|',
                                    'outdent', 'indent', '|',
                                    'undo', 'redo',
                                    '-',
                                    'fontSize', 'fontFamily', 'fontColor', 'fontBackgroundColor', 'highlight', '|',
                                    'alignment', '|',
                                    'link', 'insertImage', 'blockQuote', 'insertTable', 'mediaEmbed', 'codeBlock', 'htmlEmbed', '|',
                                    'specialCharacters', 'horizontalLine', 'pageBreak', '|',
                                    'textPartLanguage', '|',
                                    'sourceEditing'
                                ],
                                shouldNotGroupWhenFull: true
                            },
                            ckfinder: {
                                uploadUrl: Vue.prototype.$baseUrl + '/vimata/imageUpload?_token=' + token,
                            },
                            image: {
                                insert: {
                                    // This is the default configuration, you do not need to provide
                                    // this configuration key if the list content and order reflects your needs.
                                    integrations: ['upload', 'assetManager', 'url']
                                },
                                resizeOptions: [
                                    {
                                        name: 'resizeImage:original',
                                        value: null,
                                        label: 'Original'
                                    },
                                    {
                                        name: 'resizeImage:33',
                                        value: '33',
                                        label: '33%'
                                    },
                                    {
                                        name: 'resizeImage:50',
                                        value: '50',
                                        label: '50%'
                                    }
                                ]
                            },
                            // Be careful with the setting below. It instructs CKEditor to accept ALL HTML markup.
                            // https://ckeditor.com/docs/ckeditor5/latest/features/general-html-support.html#enabling-all-html-features
                            htmlSupport: {
                                allow: [
                                    {
                                        name: /.*/,
                                        attributes: true,
                                        classes: true,
                                        styles: true
                                    }
                                ]
                            },
                            // Be careful with enabling previews
                            // https://ckeditor.com/docs/ckeditor5/latest/features/html-embed.html#content-previews
                            htmlEmbed: {
                                showPreviews: true
                            },
                            mediaEmbed: {
                                previewsInData: true
                            },
                            // https://ckeditor.com/docs/ckeditor5/latest/features/link.html#custom-link-attributes-decorators
                            link: {
                                decorators: {
                                    addTargetToExternalLinks: true,
                                    defaultProtocol: 'https://',
                                    toggleDownloadable: {
                                        mode: 'manual',
                                        label: 'Downloadable',
                                        attributes: {
                                            download: 'file'
                                        }
                                    },
                                    openInNewTab: {
                                        mode: 'manual',
                                        label: 'Open in a new tab',
                                        attributes: {
                                            target: '_blank',
                                            rel: 'noopener noreferrer'
                                        }
                                    }
                                }
                            },
                            removePlugins: [
                                // These two are commercial, but you can try them out without registering to a trial.
                                // 'ExportPdf',
                                // 'ExportWord',
                                'AIAssistant',
                                'CKBox',
                                'CKFinder',
                                // 'EasyImage',
                                // This sample uses the Base64UploadAdapter to handle image uploads as it requires no configuration.
                                // https://ckeditor.com/docs/ckeditor5/latest/features/images/image-upload/base64-upload-adapter.html
                                // Storing images as Base64 is usually a very bad idea.
                                // Replace it on production website with other solutions:
                                // https://ckeditor.com/docs/ckeditor5/latest/features/images/image-upload/image-upload.html
                                'Base64UploadAdapter',
                                'RealTimeCollaborativeComments',
                                'RealTimeCollaborativeTrackChanges',
                                'RealTimeCollaborativeRevisionHistory',
                                'PresenceList',
                                'Comments',
                                'TrackChanges',
                                'TrackChangesData',
                                'RevisionHistory',
                                'Pagination',
                                'WProofreader',
                                // Careful, with the Mathtype plugin CKEditor will not load when loading this sample
                                // from a local file system (file://) - load this site via HTTP server if you enable MathType.
                                'MathType',
                                // The following features are part of the Productivity Pack and require additional license.
                                'SlashCommand',
                                'Template',
                                'DocumentOutline',
                                'FormatPainter',
                                'TableOfContents',
                                'PasteFromOfficeEnhanced'
                            ]
                        })
                        editors[i].classList.remove('js_convert_wysiwyg');
                    }

                }, 500);
            },
            deep: true
        }
    }
};
</script>